/* eslint-disable camelcase */
import './filter.scss';
import wNumb from 'wnumb';
import { RangeSlider } from '../../components/range-slider/range-slider';

class Filter {
    constructor (el, options) {
        const defaults = {
            toggleAttr: 'data-filter-toggle',
            labelAttr: 'data-filter-label',
            optionsAttr: 'data-filter-options',
            valueAttr: 'data-filter-value',
            rangeAttr: 'data-filter-range',
            resetAttr: 'data-filter-reset',
            formReset: 'data-filter-reset-form',
            offset: 10,
            positionTimeout: 400
        };

        this.settings = Object.assign({}, defaults, options);
        this.$filter = el;
        this.$filterToggles = this.$filter.querySelectorAll('[' + this.settings.toggleAttr + ']');
        this.positionTimer = '';
        this.rangeSet = false;
        this.filterTimeout = '';
        this.selectedFilter = {};
        this.$form = this.$filter.closest('form');
        this.rangeSliders = [];
        this.$filterReset = this.$filter.querySelector('[' + this.settings.formReset + ']');
        this.trackingValues = [];
        this.initialTrackingValues = [];

        this.moneyFormat = wNumb({
            mark: ',',
            thousand: '.',
            prefix: '',
            suffix: ''
        });
    }

    initialize () {
        // rangeslider handling for price slider
        this.setTracking();

        this.$form.addEventListener('submit', () => {
            this.setTracking();
        });

        this.$filter.querySelectorAll('[' + this.settings.rangeAttr + ']').forEach((rangeSliderEl, index) => {
            const $rangesliderObj = rangeSliderEl;
            const $from = $rangesliderObj.querySelector('[data-filter-rangefrom]');
            const $to = $rangesliderObj.querySelector('[data-filter-rangeto]');
            let value_from;
            let value_to;
            let value_from_formatted;
            let value_to_formatted;

            const from_text_default = $from.getAttribute(this.settings.valueAttr);
            const to_text_default = $to.getAttribute(this.settings.valueAttr);

            // eslint-disable-next-line no-unused-vars
            this.rangeSliders[index] = new RangeSlider($rangesliderObj, {
                type: 'multiple',
                from: 'data-filter-rangefrom',
                to: 'data-filter-rangeto',
                onUpdate: (values, makeFormat) => {
                    let from_text, to_text;

                    if (values.length === 2) {
                        value_from = parseInt(values[0]);
                        value_to = parseInt(values[1]);

                        value_from_formatted = this.moneyFormat.to(value_from);
                        value_to_formatted = this.moneyFormat.to(value_to);

                        $from.value = value_from_formatted;
                        $to.value = value_to_formatted;

                        from_text = from_text_default.replace('###value###', value_from_formatted);
                        to_text = to_text_default.replace('###value###', value_to_formatted);

                        if (value_from === 0) {
                            from_text = '';
                        }

                        if (makeFormat === false) {
                            $from.value = value_from;
                            $to.value = value_to;
                        }

                        $from.setAttribute(this.settings.valueAttr, from_text);
                        $to.setAttribute(this.settings.valueAttr, to_text);
                    }
                }
            });
        });

        this.$filter.querySelectorAll('[' + this.settings.optionsAttr + ']').forEach((element) => {
            const $values = element.querySelectorAll('[' + this.settings.valueAttr + ']');

            $values.forEach(value => {
                value.addEventListener('change', (element) => {
                    if (element.checked === false) {
                        this.checked = true;
                    }
                });
            });
        });

        window.addEventListener('orientationchange', () => {
            const $active = this.$filter.querySelector('[' + this.settings.toggleAttr + ']:checked');

            if ($active) {
                $active.checked = false;
            }
        });

        // set defaults by input values
        this.$filterToggles.forEach(($filtertoggle) => {
            const $label = $filtertoggle.parentNode.querySelector('[' + this.settings.labelAttr + ']');
            $label.setAttribute(this.settings.labelAttr, $label.textContent.trim());

            this.getFilterOptions($filtertoggle);
            this.setResetFilter($filtertoggle);
            this.toggleEvent($filtertoggle);
        });

        // this.setTracking();
        if (window.innerWidth < 768) {
            const freezeVp = (e) => {
                e.preventDefault();
            };

            const stopBodyScrolling = (bool) => {
                if (bool === true) {
                    document.body.addEventListener('touchmove', freezeVp, { passive: false });
                } else {
                    document.body.removeEventListener('touchmove', freezeVp, { passive: false });
                }
            };

            const $filterToggles = document.querySelectorAll('[data-filter-toggle]');

            if ($filterToggles.length > 0) {
                $filterToggles.forEach((filterToggle) => {
                    filterToggle.addEventListener('change', () => {
                        if (filterToggle.checked === true) {
                            stopBodyScrolling(true);
                            document.body.classList.add('no-scroll');
                        } else {
                            stopBodyScrolling(false);
                            document.body.classList.remove('no-scroll');
                        }
                    });
                });
            }
        }

        if (this.$filterReset) {
            this.$filterReset.addEventListener('click', () => {
                const $activeResetFilter = this.$filter.querySelectorAll('[' + this.settings.resetAttr + '].is--visible');

                if ($activeResetFilter.length > 0) {
                    $activeResetFilter.forEach(($filter) => {
                        $filter.click();
                    });
                }
            });
        }
    }

    toggleEvent (toggle) {
        // trigger toggles for calculations
        toggle.addEventListener('change', (e) => {
            const $current = e.target;
            const $currentLabel = $current.parentNode.querySelector('[' + this.settings.labelAttr + ']');
            const targetID = e.target.id;

            if ($current.checked === false) {
                this.getFilterOptions($current);
                clearTimeout(this.filterTimeout);
                this.filterTimeout = window.setTimeout(() => {
                    this.$filter.classList.remove('filter--opened');
                }, 500);

                const $currentOptions = $current.parentNode.querySelector('[data-filter-options]');
                const $currentSelectedCheckboxes = $currentOptions.querySelectorAll('input[type="checkbox"]:checked');

                if ($currentSelectedCheckboxes.length > 0) {
                    let nowSelected = '';

                    $currentSelectedCheckboxes.forEach((checkbox) => {
                        nowSelected += checkbox.value;
                    });

                    if (nowSelected !== this.selectedFilter['"' + e.target.id + '"']) {
                        this.$form.dispatchEvent(new Event('submit', {
                            cancelable: true
                        }));
                    }
                } else {
                    this.$form.dispatchEvent(new Event('submit', {
                        cancelable: true
                    }));
                }

                this.setRangeInputs(false);
            } else {
                const $selectedCheckboxes = $current.parentNode.querySelector('[data-filter-options]').querySelectorAll('input[type="checkbox"]:checked');
                const $selectedText = $current.parentNode.querySelector('[data-filter-options]').querySelectorAll('input[type="text"]');

                if ($selectedCheckboxes.length > 0) {
                    let newSelected = '';

                    $selectedCheckboxes.forEach((checkbox) => {
                        newSelected += checkbox.value;
                    });
                    this.selectedFilter['"' + targetID + '"'] = newSelected;
                } else {
                    $selectedText.forEach((el) => {
                        this.selectedFilter['"' + el.id + '"'] = el.value.replace('.', '');
                    });
                }
                clearTimeout(this.filterTimeout);
                this.$filter.classList.add('filter--opened');
                if ($currentLabel.getAttribute('data-filter-type') === 'range') {
                    this.rangeSet = true;
                }
                this.setRangeInputs(true);
            }

            this.setPosition($current, $current.checked);

            this.$filterToggles.forEach((filterToggle) => {
                if (filterToggle !== e.target) {
                    if (this.checked === true) {
                        this.checked = false;
                        this.getFilterOptions(filterToggle);
                    }
                }
            });
        });
    }

    // gets the input values and sets label text
    getFilterOptions ($currentFilter) {
        const $currentOptions = $currentFilter.parentNode.querySelector('[' + this.settings.optionsAttr + ']');
        const $currentLabel = $currentFilter.parentNode.querySelector('[' + this.settings.labelAttr + ']');
        const $currentReset = $currentFilter.parentNode.querySelector('[' + this.settings.resetAttr + ']');
        const filterValues = [];
        let filterValuesText;
        let filterJoin;

        $currentOptions.querySelectorAll('[type="checkbox"]:checked').forEach(element => {
            if (typeof element.getAttribute(this.settings.valueAttr) !== 'undefined' && element.getAttribute(this.settings.valueAttr) !== '') {
                const valueText = element.getAttribute(this.settings.valueAttr);
                filterValues.push(valueText);
            }
            filterJoin = ', ';
        });

        $currentOptions.querySelectorAll('[type="text"]').forEach((element) => {
            if (element.value !== '') {
                if (typeof element.getAttribute(this.settings.valueAttr) !== 'undefined' && element.getAttribute(this.settings.valueAttr) !== '') {
                    const valueText = element.getAttribute(this.settings.valueAttr);
                    filterValues.push(valueText);
                }
            }

            filterJoin = ' ';
        });

        if (filterValues.length > 3) {
            filterValuesText = '';
            for (let i = 0; i < 3; i++) {
                filterValuesText = filterValuesText + filterValues[i] + ', ';
            }
            filterValuesText = filterValuesText + '...';
        } else {
            filterValuesText = filterValues.join(filterJoin);
        }

        if (filterValuesText !== '') {
            $currentLabel.innerHTML = '<span>' + filterValuesText + '</span>';
            if ($currentLabel.dataset.filterType === 'range') {
                const $RangeFrom = document.querySelector('[data-filter-rangefrom]');
                const $RangeTo = document.querySelector('[data-filter-rangeto]');
                if ($RangeFrom.value !== $RangeFrom.getAttribute('data-filter-rangefrom') || $RangeTo.value !== $RangeTo.getAttribute('data-filter-rangeto')) {
                    $currentReset.classList.add('is--visible');
                }
            } else {
                $currentReset.classList.add('is--visible');
            }
        } else {
            $currentLabel.innerHTML = '<span>' + $currentLabel.getAttribute(this.settings.labelAttr) + '</span>';
            $currentReset.classList.remove('is--visible');
        }
    }

    // Reset the Filter to default
    setResetFilter ($currentFilter) {
        const $currentOptions = $currentFilter.parentNode.querySelector('[' + this.settings.optionsAttr + ']');
        const $currentReset = $currentFilter.parentNode.querySelector('[' + this.settings.resetAttr + ']');
        const type = $currentReset.getAttribute(this.settings.resetAttr);

        $currentReset.addEventListener('click', () => {
            switch (type) {
            case 'select':
                $currentOptions.querySelectorAll('[type="checkbox"]:checked').forEach((element) => {
                    element.checked = false;
                });
                break;
            case 'range':
                this.rangeSliders[0].settings.destroyAndRenew();
                break;
            }

            this.getFilterOptions($currentFilter);
            $currentReset.classList.remove('is--visible');

            // this.setTracking();
            this.$form.dispatchEvent(new Event('submit', {
                cancelable: true
            }));
        });
    }

    setPosition ($currentFilter, isChecked) {
        const $currentOptions = $currentFilter.parentNode.querySelector('[' + this.settings.optionsAttr + ']');
        const bounds = $currentOptions.getBoundingClientRect();
        let difference = 0;
        clearTimeout(this.positionTimer);
        if (isChecked === true) {
            if (window.innerWidth < bounds.right) {
                difference = (bounds.right - window.innerWidth + this.settings.offset) * -1;
                $currentOptions.style.marginLeft = difference + 'px';
            }
        } else {
            this.positionTimer = window.setTimeout(() => {
                $currentOptions.style.marginLeft = 0;
            }, this.settings.positionTimeout);
        }
    }

    setRangeInputs (open) {
        this.$filter.querySelectorAll('[' + this.settings.rangeAttr + ']').forEach((rangeSlider) => {
            const $rangesliderObj = rangeSlider;
            const $from = $rangesliderObj.querySelector('[data-filter-rangefrom]');
            const $to = $rangesliderObj.querySelector('[data-filter-rangeto]');
            let fromValue = $from.value;
            let toValue = $to.value;
            let fromFormatted; let toFormatted;

            fromValue = fromValue.replace('.', '');
            toValue = toValue.replace('.', '');

            fromValue = parseInt(fromValue);
            toValue = parseInt(toValue);

            if (open === true) {
                fromFormatted = this.moneyFormat.to(fromValue);
                toFormatted = this.moneyFormat.to(toValue);
            } else {
                fromFormatted = fromValue;
                toFormatted = toValue;
            }

            if (open === 'reset') {
                $from.value = $from.dataset.filterRangefrom;
                $to.value = $to.dataset.filterRangeto;
            } else {
                $from.value = fromFormatted;
                $to.value = toFormatted;
            }
        });
    }

    setTracking () {
        clearTimeout(window.trackingTimeout);
        window.trackingTimeout = window.setTimeout(() => {
            this.trackingValues = [];
            const $filters = this.$form.querySelectorAll('.filter__item');

            $filters.forEach($filter => {
                const $filterLabel = $filter.querySelector('[data-tracking-label]');

                if (!$filterLabel) {
                    return;
                }

                const filterLabel = $filterLabel.getAttribute('data-tracking-label');
                const $currentOptions = $filter.querySelector('[' + this.settings.optionsAttr + ']');
                const filterValues = [];
                let filterJoin = '';

                $currentOptions.querySelectorAll('[type="checkbox"]:checked').forEach($option => {
                    if (typeof $option.getAttribute(this.settings.valueAttr) !== 'undefined' && $option.getAttribute(this.settings.valueAttr) !== '') {
                        const valueText = $option.getAttribute(this.settings.valueAttr);
                        filterValues.push(valueText);
                    }
                    filterJoin = ', ';
                });

                $currentOptions.querySelectorAll('[type="text"]').forEach(($option) => {
                    if ($option.value !== '') {
                        if (typeof $option.getAttribute(this.settings.valueAttr) !== 'undefined' && $option.getAttribute(this.settings.valueAttr) !== '') {
                            const valueText = $option.getAttribute(this.settings.valueAttr);
                            filterValues.push(valueText);
                        }
                    }

                    filterJoin = ' ';
                });

                const filterValuesText = filterValues.join(filterJoin);
                if (filterValuesText !== '') {
                    const filterDetail = {
                        name: filterLabel,
                        list: filterValuesText
                    };
                    this.trackingValues.push(filterDetail);
                }
            });

            const trackingData = {
                event: 'filter',
                filter_detail: this.trackingValues
            };

            const $resultCount = this.$form.querySelector('[data-filter-count]');
            if ($resultCount) {
                const resultCount = $resultCount.getAttribute('data-filter-count');

                trackingData.filter_results = resultCount;
            }

            console.log(trackingData);

            if (window.dataLayer) {
                window.dataLayer.push(trackingData);
            }
        }, 500);
    }
}

export { Filter };
